module.exports = __webpack_public_path__ + "img/LL11X5.png";